import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../Button";

const ContactUs = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [socialHandle, setSocialHandle] = useState("");
  const [service, setService] = useState("");
  const [projectDesc, setProjectDesc] = useState("");
  const [budget, setBudget] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email || !service || !projectDesc) {
      setAlertMessage("Please fill in all required fields.");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch("https://api.nxtamedia.com/api/contactus/post", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          phone,
          socialHandle,
          service,
          projectDesc,
          budget,
        }),
      });

      const data = await response.json();
      setLoading(false);

      if (response.ok) {
        setAlertMessage("Thank you! We will get back to you within 24 hours.");
        setTimeout(() => navigate("/thank-you"), 2000);

        // Clear form
        setName("");
        setEmail("");
        setPhone("");
        setSocialHandle("");
        setService("");
        setProjectDesc("");
        setBudget("");
      } else {
        setAlertMessage(data.message || "Something went wrong.");
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
      setAlertMessage("Server error. Please try again later.");
    }
  };

  return (
    <div className="max-w-xl mx-auto bg-gray-900 rounded-xl shadow-lg p-6 md:p-10 text-white relative my-10">
      {alertMessage && (
        <div className="bg-green-600 text-white p-3 rounded mb-4 text-center text-sm">
          {alertMessage}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Full Name *"
          className="w-full px-4 py-1 rounded bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email *"
          className="w-full px-4 py-1 rounded bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <input
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="Phone (optional)"
          className="w-full px-4 py-1 rounded bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <input
          type="text"
          value={socialHandle}
          onChange={(e) => setSocialHandle(e.target.value)}
          placeholder="Your Social Media Handle"
          className="w-full px-4 py-1 rounded bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <select
          value={service}
          onChange={(e) => setService(e.target.value)}
          className="w-full px-4 text-gray-400 py-1 rounded bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-primary"
        >
          <option value="">Which service are you looking for? *</option>
          <option value="Social Media">Social Media</option>
          <option value="Video Editing">Video Editing</option>
          <option value="Web Design">Web Design</option>
          <option value="Other">Other</option>
        </select>
        <textarea
          value={projectDesc}
          onChange={(e) => setProjectDesc(e.target.value)}
          placeholder="Tell us about your project *"
          className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-primary resize-none h-24"
        />
        <input
          type="text"
          value={budget}
          onChange={(e) => setBudget(e.target.value)}
          placeholder="Estimated budget (optional)"
          className="w-full px-4 py-2 rounded bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-primary"
        />

        <Button type="submit" variant="solid" className="w-full">
          {loading ? "Sending..." : "Send Message"}
        </Button>
      </form>
    </div>
  );
};

export default ContactUs;
